// Resolve an image URL that may be either:
//   - An absolute URL (legacy customer-assets.emergentagent.com)
//   - A backend-relative path like `/api/files/...`
// We always return a fully-qualified URL that <img src> can use.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/')) return `${BACKEND_URL}${url}`;
  return url;
};
